import * as React from 'react';
import { StoreContext } from '../../../appContext/StoreProvider';
import { getLinks } from '../utils';
import { TopBarNavigationLinks } from './TopBarNavigationLinks';

export const TopBarNavigation = () => {
  const { store } = React.useContext(StoreContext);

  const headerLinks = getLinks(store.viewer.category);
  return <TopBarNavigationLinks links={headerLinks} />;
};
